
const ImageGallery = () => import(/* webpackChunkName: 'image-gallery' */ './src/views/0000/GalleryDisplay')

const install = function(Vue, _globalOptions) {
  if (process.env.SERVER_BUILD !== 'ssr') {
    const Photoswipe = () => import(/* webpackChunkName: 'image-gallery' */ 'vue-pswipe')
      .then(({ Photoswipe }) => Photoswipe)
    Vue.component('Photoswipe', Photoswipe)
  }
  Vue.component('ImageGallery', ImageGallery)
}

export default { ImageGallery, install }
